import React, {useCallback, useEffect, useState} from "react";
import {ModalOverlay} from "components/Modal";
import styled from "styled-components";
import {ButtonPrimary, CheckBox, FormGroup} from "components/FormElements";
import {useDispatch, useSelector} from "react-redux";
import {userRegisterForGame} from "modules/actions";
import {ReturnFormNames} from "modules/utils";
import {isNeedToRegisterForGame} from "modules/selectors";
import {Link, useLocation} from "react-router-dom";
import banner from "assets/img/banner.jpg";

const Modal = styled.div`
	background: #fff;
	width: 100%;
	max-width: 414px;
	box-sizing: border-box;
	max-height: 100%;
	max-height: 100vh;
	position: relative;
	overflow: auto;

	form > div {
		margin: 0 auto;
		width: 240px;
	}
	button {
		margin-top: 10px;
	}
`;
const ModalHeader = styled.header`
	height: 70px;
	color: #ffffff;
	font-size: 27px;
	letter-spacing: 0;
	line-height: 50px;
	text-align: center;
	font-weight: 600;
	img {
		height: 70px;
	}
`;
const ModalInner = styled.div`
	padding: 20px 40px 30px;
`;

const Text = styled.p`
	color: #000000;
	font-family: "Heebo", sans-serif;
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 20px;
	margin-bottom: 20px;
`;

export const ModalRegisterForGame: React.FC = () => {
	const dispatch = useDispatch();
	const is_returning_user = useSelector(isNeedToRegisterForGame);
	const location = useLocation();
	const [hide_modal, setModalState] = useState(!is_returning_user);
	const [values, updateValue] = useState({
		[ReturnFormNames.Sponsor]: false,
		[ReturnFormNames.Terms]: false,
	});
	const [isDisabled, handleSubmitButton] = useState(true);
	const terms_link = "/help/rules";

	// Hide modal and show Terms
	useEffect(() => {
		if (is_returning_user) {
			setModalState(location.pathname === terms_link);
		}
	}, [location.pathname, is_returning_user]);

	const handleChange = useCallback(
		(event: React.SyntheticEvent<HTMLInputElement>) => {
			const {name, checked} = event.currentTarget;
			updateValue({
				...values,
				[name]: checked,
			});
		},
		[values]
	);

	const onSubmit = useCallback(
		(event: React.SyntheticEvent<HTMLFormElement>) => {
			event.preventDefault();
			event.stopPropagation();

			if (!event.currentTarget.checkValidity()) {
				return;
			}
			dispatch(
				userRegisterForGame({
					[ReturnFormNames.Sponsor]: values[ReturnFormNames.Sponsor] ? 1 : 0,
				})
			);
			setModalState(true);
		},
		[dispatch, values]
	);

	useEffect(() => {
		handleSubmitButton(!values[ReturnFormNames.Terms]);
	}, [values]);

	if (hide_modal) {
		return null;
	}
	return (
		<ModalOverlay>
			<Modal>
				<ModalHeader>
					<img src={banner} alt="" />
				</ModalHeader>
				<ModalInner>
					<Text>
						Welcome to MotoGP™ Fantasy! Because you already have a MotoGP™ registered
						account, all you need to start playing is to accept the Terms & Conditions
					</Text>
					<form onSubmit={onSubmit}>
						<FormGroup>
							<CheckBox
								name={ReturnFormNames.Terms}
								title="Accepting the Terms & Conditions"
								tick_position="left"
								is_on_light={true}
								required={true}
								onChange={handleChange}>
								I have read and accept the{" "}
								<Link to={terms_link} rel="noopener noreferrer" target="_blank">
									legal conditions of the Fantasy MotoGP™ Game
								</Link>
								, confirming that I am over 16 years old
							</CheckBox>
						</FormGroup>
						<ButtonPrimary disabled={isDisabled} id="register-button" type="submit">
							Start
						</ButtonPrimary>
					</form>
				</ModalInner>
			</Modal>
		</ModalOverlay>
	);
};
